/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

export const CLEAR_SIGN_UP = '@@wsp/account/signUp/CLEAR'
export const CLEAR_SIGN_UP_FIELD_ERROR =
  '@@wsp/account/signUp/CLEAR_FIELD_ERROR'
export const SET_SIGN_UP_ERROR = '@@wsp/account/signUp/SET_SIGN_UP_ERROR'
export const SET_SIGN_UP_FIRST_NAME =
  '@@wsp/account/signUp/SET_SIGN_UP_FIRST_NAME'
export const SET_SIGN_UP_LAST_NAME =
  '@@wsp/account/signUp/SET_SIGN_UP_LAST_NAME'
export const SET_SIGN_UP_PHONE = '@@wsp/account/signUp/SET_SIGN_UP_PHONE'
